export const SEASONAL_TEMPORAL_CLASSES = ["HPH", "HCH", "HCB", "HPB"] as const
